import moment from 'moment';
import {SEC_IN_DAY} from 'app/utils/Consts';

export const isNewNews = (newsDate: number): boolean => {
    if (typeof newsDate !== 'number') {
        return false;
    }
    return moment().unix() - newsDate < SEC_IN_DAY;
};
